var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0735 10.4015C11.9543 11.28 12.8216 12.1518 13.6956 13.0214C13.9326 13.2561 14.0555 13.5244 13.9728 13.8619C13.8231 14.4677 13.1144 14.7024 12.6361 14.3001C12.5176 14.1995 12.4125 14.0855 12.3007 13.9759C11.5116 13.1891 10.7248 12.4 9.93568 11.6131C9.92673 11.6042 9.91556 11.5975 9.89097 11.5818C8.22111 12.7778 6.3836 13.1444 4.39632 12.5676C2.95001 12.1474 1.81666 11.2845 0.998495 10.026C-0.660182 7.47759 -0.210864 4.09541 2.03796 2.08577C4.32926 0.0381303 7.72038 -0.033403 10.0899 1.91141C12.5265 3.91434 13.1524 7.64971 11.0735 10.4015ZM6.16677 11.166C8.65925 11.1638 10.6599 9.16085 10.6622 6.6706C10.6644 4.17141 8.65478 2.16401 6.15559 2.16624C3.66534 2.16624 1.66465 4.16917 1.66241 6.66166C1.66018 9.16085 3.66758 11.1683 6.16677 11.166Z",
    fill: "#545454",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.52bfa1a83874c50cc9da58b845d47819.svg";
export { ForwardRef as ReactComponent };